import { render, staticRenderFns } from "./MaintTips.vue?vue&type=template&id=a16fa752&scoped=true"
import script from "./MaintTips.vue?vue&type=script&lang=js"
export * from "./MaintTips.vue?vue&type=script&lang=js"
import style0 from "./MaintTips.vue?vue&type=style&index=0&id=a16fa752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16fa752",
  null
  
)

export default component.exports